import React, { createContext, useContext, useEffect, useState } from 'react';
import { useWorkspace } from '../../context/WorkspaceContext';

interface AdminContextValue {
    selectedBusinessId: string;
    setSelectedBusinessId: (id: string) => void;
}

const AdminContext = createContext<AdminContextValue>({
    selectedBusinessId: '',
    setSelectedBusinessId: () => {},
});

const ADMIN_SELECTED_BUSINESS_STORAGE_KEY = 'admin:selectedBusinessId';

export const useAdminContext = () => useContext(AdminContext);

export const AdminContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { activeBusinessId, setActiveBusinessId } = useWorkspace();
    const [selectedBusinessId, setSelectedBusinessIdState] = useState(() => {
        if (typeof window === 'undefined') return activeBusinessId || '';
        return window.localStorage.getItem(ADMIN_SELECTED_BUSINESS_STORAGE_KEY) || activeBusinessId || '';
    });

    useEffect(() => {
        if (typeof window === 'undefined') return;
        if (selectedBusinessId) {
            window.localStorage.setItem(ADMIN_SELECTED_BUSINESS_STORAGE_KEY, selectedBusinessId);
            return;
        }
        window.localStorage.removeItem(ADMIN_SELECTED_BUSINESS_STORAGE_KEY);
    }, [selectedBusinessId]);

    return (
        <AdminContext.Provider
            value={{
                selectedBusinessId,
                setSelectedBusinessId: (id: string) => {
                    setSelectedBusinessIdState(id);
                    setActiveBusinessId(id || null);
                },
            }}
        >
            {children}
        </AdminContext.Provider>
    );
};
